<script setup>
import { router, useForm } from '@inertiajs/vue3';
import { onMounted } from 'vue';
import AppLayout from '@/Layouts/AppLayout.vue';
import { reactive } from 'vue';
import JetButton from '@/Jetstream/Button.vue';
import { ref } from 'vue';
import DashboardSidebar from '@/Jetstream/DashboardSidebar.vue';
import CustomQuestionField from '@/Pages/CustomQuestions/CustomQuestionField.vue';

const customRegistrationFields = [];

const props = defineProps({
    loggedInUserId: Number,
    userAnswers: Array
});

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;
const urlNamePrefix = organisation ? "gi." : "";
const userID = router.page.props.auth.user.id;
const user = router.page.props.auth.user;
const userAnswers = props.userAnswers;
const programme_custom_fields = programme.custom_registration_fields;

let organisation_custom_fields = [];
if (organisation) {
    organisation_custom_fields = organisation.custom_registration_fields;
}
const custom_questions = programme_custom_fields.concat(organisation_custom_fields);

// Create formData reactive array
const formData = reactive([]);

//Loop through each custom question and build the formData reactive array.
let question_id = 0;
custom_questions.forEach(function (custom_question) {
    formData.push({
        "index_id": question_id,
        "input_type": custom_question.type,
        "question_id": custom_question.id,
        "user_id": userID,
        "answer": ''
    });
    custom_question["index_id"] = question_id;
    question_id++;
});

let formDataItemQuestionID;
formData.forEach(function (formDataItem) {
    formDataItemQuestionID = formDataItem.question_id;

    userAnswers.forEach(function (userAnswer) {
        if ( userAnswer.question_id == formDataItemQuestionID ) {
            if(formDataItem.input_type == 'checkbox') {
                userAnswer.answer = (userAnswer.answer == '1' ? 'true' : userAnswer.answer);
            }

            formDataItem.answer = userAnswer.answer;

        }
    });
});

savingSuccessful: false

const displaySuccessMessage = () => {
    const saveSuccessAlert = document.getElementById('alert-save-success');
    saveSuccessAlert.classList.remove('alert-hidden');
}

onMounted(() => {
    $('.alert-close').on('click', function (e) {
    e.preventDefault();
        $('#alert-save-success').addClass('alert-hidden');
   });
});

// This is the function that posts updated field data to the database
const UpdateCustomQuestions = ($event) => {

    formData.forEach(function (formDataItem) {
        delete formDataItem.index_id;
    });

    router.post(route(urlNamePrefix+'custom-questions.update'),
    {
        formData
    }, {
        preserveState: true,
        preserveScroll: true,
        onSuccess: function() {
            displaySuccessMessage();

        },
        onError: (errors) => {
        },

    });

}

</script>

<template>
    <AppLayout title="Dashboard">

        <div class="container flex flex-col justify-between w-full mx-auto lg:flex-row">

            <div id="sos-programme-dashboard-sidebar" class="order-2 w-full min-h-screen p-10 pt-5 lg:order-1 lg:w-1/4 xl:w-1/5">
                <DashboardSidebar :programme="programme" :organisation="organisation" />
            </div>

            <div id="sos-programme-dashboard-content" class="order-1 w-full lg:order-2 lg:w-3/4 xl:w-4/5 sos-programme-dashboard-content">
                <div class="overflow-hidden">
                    <h2 class="pt-5 pl-10 dashboard-title">
                        {{ $t('user.questions.title') }}
                    </h2>
                    <p class="pl-10 text-lg font-bold">
                        {{ $t('user.questions.info') }}
                    </p>

                    <div id="alert-save-success" class="p-5 ml-10 bg-green-100 rounded alert alert-success alert-hidden">
                        <div class="flex justify-between">
                            <div class="flex space-x-3">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="flex-none w-4 h-4 text-green-500 fill-current">
                                <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.25 16.518l-4.5-4.319 1.396-1.435 3.078 2.937 6.105-6.218 1.421 1.409-7.5 7.626z" /></svg>
                                <div class="flex-1 text-sm font-medium leading-tight text-green-700">{{ $t('user.questions.saved') }}</div>
                            </div>
                            <button class="alert-close">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="flex-none w-3 h-3 text-green-600 fill-current">
                                <path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z" /></svg>
                            </button>
                        </div>
                    </div>

                    <div class="flex flex-wrap p-10 pt-5 lg:pr-0">

                        <div class="w-full p-6 mb-5 bg-white border-b border-gray-200 sm:px-20 rounded-2xl">
                            <div v-if="custom_questions.length !== 0" class="mt-6 text-gray-500">

                                <h3>{{ $t('user.questions.description') }}</h3>
                                <p v-html="$t('user.questions.required')"></p>

                                <form @submit.prevent="UpdateCustomQuestions">

                                    <div v-if="custom_questions.length !== 0">
                                        <CustomQuestionField
                                        v-for="custom_question in custom_questions"
                                        :custom_question="custom_question"
                                        :key="custom_question.index_id"
                                        :formData="formData"
                                        :datePicker="datePicker" />
                                    </div>


                                    <JetButton
                                        type="submit"
                                        class="justify-center rounded btn btn-toolkit-primary"
                                        >
                                        {{ $t('user.questions.save') }}
                                    </JetButton>

                                </form>

                            </div>
                            <div v-else>
                                <h3>{{ $t('user.questions.not_requested') }}</h3>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>
